<template>
  <b-input-group class="bg-white">
    <template #prepend>
      <div class="d-flex align-items-center px-3">
        <b-icon-search variant="primary"></b-icon-search>
      </div>
    </template>
    <template #append>
      <div
        v-if="column.search_meta.total >= 0"
        class="d-flex align-items-center px-3 text-muted"
      >
        {{
          numberDeclension(column.search_meta.total || 0, [
            "сделка",
            "сделки",
            "сделок",
          ])
        }}
      </div>
    </template>
    <b-form-input
      v-if="!!!searchResult"
      placeholder="Поиск"
      @input="$emit('search', column)"
      v-model="column.search"
      class="border-0 py-1 pr-3 pl-0"
    />

    <b-form-input
      v-if="!!searchResult"
      disabled
      class="border-0 py-1 pr-3 pl-0"
    />
  </b-input-group>
</template>

<script>
export default {
  props: {
    column: {
      type: Object,
      required: true,
    },
    searchResult: {
      type: String,
      default: '',
    },
  },
};
</script>
